'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');
require('./partials/tab.js');
require('./partials/tabPanel.js');
const performanceMeasure = require('../../lib/performanceMeasure.js');
let measure = performanceMeasure('webcomponents:tabs');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * @class
     * PhoenixTabs
     *
     * @classdesc
     * PhoenixTabs is a Web Component to create Tab UI.
     *
     * @example
     * <phoenix-tabs class="m-tabs" enable-hash id="{uniqueId}"> // id is optional
     *  <phoenix-tab for="{uniqueId}-panel-1 tabindex="0" aria-selected="true">Tab 1</phoenix-tab>
     *  <phoenix-tab for="{uniqueId}-panel-2" tabindex="-1" aria-selected="false" >Tab 2</phoenix-tab>
     *  <phoenix-tab-panel hidden aria-hidden="false" id="{uniqueId}-panel-1">Panel 1</phoenix-tab-panel>
     *  <phoenix-tab-panel hidden aria-hidden="true" id="{uniqueId}-panel-2">Panel 2</phoenix-tab-panel>
     * </phoenix-tab>
     */

    class PhoenixTabs extends pageClass.PhoenixElement {
        get observedEmittedEvents() {
            return ['phoenix:tab'];
        }

        get hash() {
            return window.location.hash.replace('#', '');
        }

        set hash(val) {
            window.location.hash = val;
        }

        get activeTabId() {
            return this._activeTabId;
        }

        set activeTabId(id) {
            this._activeTabId = id;
        }

        connectedCallback() {
            super.connectedCallback();

            if (!this.id) {
                this.id = Math.random().toString(36).substr(2, 9);
            }

            this.hashEnabled = this.hasAttribute('enable-hash');
        }

        emittedEventCallback(name, args = {}) {
            const tabsId = args.detail && args.detail.tabsId;
            const panelId = args.detail && args.detail.panelId;

            if (tabsId !== this.id) {
                return;
            }

            if (name === 'phoenix:tab') {
                this._notify(tabsId, panelId);
            }
        }

        _notify(tabsId, panelId) {
            this.activeTabId = panelId;
            const eventName = 'phoenix:tab:active';
            this.emitEvent(eventName, {
                bubbles: true,
                detail: {
                    key: eventName,
                    tabsId,
                    panelId,
                },
            });
        }
    }

    window.customElements.define('phoenix-tabs', PhoenixTabs);
    measure.end();
});
